import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { QRCodeModel } from './qrcode.model';
import { environment } from '../../../environments/environment';

const LIST_ENDPOINT = '/scanned-codes';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class QRCodeService {
  private readonly http = inject(HttpClient);

  async sendQR(qrCode: QRCodeModel): Promise<string> {
    const response = await firstValueFrom(
      this.http.post<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT, qrCode)
    );

    return response.message;
  }
}